import { triggerBlobDownload } from '../../../../utils/http/responseHelpers';
import {
  createStatisticsExportSnapshot,
  type StatisticsExportOptions,
} from './statisticsExportModel';
import { buildStatisticsWorkbook } from './statisticsWorkbook';

const XLSX_MIME =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const exportStatistics = async (
  options: StatisticsExportOptions,
): Promise<void> => {
  const snapshot = createStatisticsExportSnapshot(options);
  const ExcelJS = await import('exceljs');
  const workbook = buildStatisticsWorkbook(new ExcelJS.Workbook(), snapshot);
  const buffer = await workbook.xlsx.writeBuffer();
  triggerBlobDownload(
    new Blob([buffer], { type: XLSX_MIME }),
    snapshot.fileName,
  );
};
